import React from 'react'
import {
  BsClipboardData,
  BsGraphUp,
  BsBuilding,
  BsKey,
  BsPercent,
  BsPaperclip,
  BsFileEarmarkText,
  BsShieldCheck,          // 🔥 Alternative to Bssupport (customer support headset)
  BsHandThumbsUp        // 🔥 Alternative for closing or ending
} from "react-icons/bs";

import { FaHome, FaKey, FaMoneyBillWave, FaBriefcase, FaShoppingBag, FaComments } from "react-icons/fa";
import Footer from './Footer';
import cityback from "../cta-bg.png";

const WhyUs = () => {
  const steps = [
    {
      number: "01",
      title: "Understanding Requirements",
      description:
        "At Alketbi  REAL ESTATE , we gather information about their specific requirements, including budget, preferred location, property type, size, amenities, and any other preferences.",
      icon: <BsClipboardData />,
    },
    {
      number: "02",
      title: "Market Analysis",
      description:
        "We conducts a comprehensive market analysis to identify suitable properties that match the customer's criteria.",
      icon: <BsGraphUp />,
    },
    {
      number: "03",
      title: "Property Selection",
      description:
        "Based on the customer's preferences, We presents a curated selection of properties for review.",
      icon: <BsBuilding />,
    },
    {
      number: "04",
      title: "Viewings",
      description:
        "We arranges property viewings for the customer to explore selected properties firsthand.",
      icon: <BsKey />,
    },
  
    { number: "05",
           title: "Offer Submission", 
           description: "Once the customer identifies a property of interest, Saeed Alketbi assists in preparing and submitting an offer to the seller or landlord on behalf of the customer. The agent negotiates terms and conditions to secure the best possible deal for the customer.", 
           icon:<BsPercent />,
        },
        {
          number: "06",
          title: "Due Diligence Process",
          description:"Upon acceptance of the offer,  Alketbi  REAL ESTATE facilitates the due diligence process, which may include property inspections, appraisal, title search, and review of legal documents." ,         
        icon: <BsPaperclip />,
        },
        {
          number: "07",
          title: "Documentation and Contract Signing",
          description:" Alketbi REAL ESTATE assists the customer in completing the necessary paperwork and contracts required for the transaction. They ensure that all legal and financial aspects are properly addressed to protect the interests of the customer." ,         
        icon: <BsFileEarmarkText />,
        },
        {
          number: "08",
          title: "Closing",
          description:"Alketbi REAL ESTATE coordinates the closing process, including finalizing payments, transferring ownership or tenancy rights to the customer." ,         
        icon: <BsShieldCheck />,
        },
        {
          number: "09",
          title: "Post-Sale Support",
          description:"After the transaction is completed,  We continues to provide support to the customer as needed. This may include assistance with moving logistics, property management services, or any other post-sale inquiries or concerns.",
          icon: <BsHandThumbsUp />,
        }

      
  ];
  const services = [
    {
      title: "Buy",
      description:
        "Unlock your dream home with our tailored buying service. From consultation to closing, we guide you through every step, ensuring a seamless and satisfying property purchase experience.",
      icon: <FaHome />,
    },
    {
      title: "Sell",
      description:
        "Ready to sell your property? Trust our seasoned experts to maximize your return. From strategic marketing to seamless transactions, we handle it all.",
      icon: <FaKey />,
    },
    {
      title: "Rental",
      description:
        "Turn your property into profit with ease. Our rental service handles everything from listing to tenant screening, ensuring a hassle-free experience and maximizing your rental income.",
      icon: <FaMoneyBillWave />,
    },
    {
      title: "Mortgage Assistance",
      description:
        "Navigate the complexities of mortgages effortlessly with our expert assistance. From finding the best rates to securing approvals, we guide you every step of the way.",
      icon: <FaBriefcase />,
    },
    {
      title: "Portfolio Management",
      description:
        "Portfolio Management Service involves overseeing and optimizing an individual’s or investor’s entire real estate portfolio.",
      icon: <FaShoppingBag />,
    },
    {
      title: "Post Sales Service",
      description:
        "Post-sales service includes comprehensive support such as providing essential documentation, visa assistance, and property management.",
      icon: <FaComments />,
      bg: "bg-[#9A7B4F] text-white",
    },
  ];
  

  return (
    <div className=" overflow-hidden">
      <div className="bg-[#f9f6f6] py-20 xsm:py-7 md:py-10 flex flex-col items-center">
        <div className=" lg:w-[80%] md:w-[70%] xsm:w-[70%] mx-auto rounded-2xl overflow-hidden shadow-lg">
          <img
            src="why-us-banner.png"
            alt="Dubai Skyline"
            className="w-full object-cover rounded-t-2xl"
          />
        </div>
        <div className="p-10 xsm:flex-col lg:flex-row flex md:flex-col justify-center items-center">
          <h2 className="text-4xl font-extrabold mb-6 xsm:text-sm xsm:w-full w-[40%]">Why Saeed Alketbi</h2>
          <p className="text-lg text-gray-700 xsm:w-full xsm:text-xs text-justify leading-relaxed w-[40%]">
            At  Alketbi REAL ESTATE , we put you first. Our customer-centric approach ensures your needs are our priority.
            With research-driven analysis, we tailor solutions to match your goals. From property selection
            to post-sale support, we’re here for you every step of the way!
          </p>
        </div>
      </div>

{/* Process Section */}
<div className="max-w-6xl mx-auto py-16 px-4">
  <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">Our Process</h2>

  {/* Timeline Container */}
  <div className="relative">
    {/* Vertical Line */}
    <div className="absolute left-1/2 transform -translate-x-1/2 top-0 h-full w-1 bg-[#9A7B4F]"></div>

    {steps.map((step, index) => (
      <div
        key={index}
        className={`flex items-center mb-20 relative group ${
          index % 2 === 0 ? "justify-start" : "justify-end"
        }`}
      >
        {/* Content Box */}
        <div
          className={`relative z-10 bg-slate-100 rounded-2xl shadow-2xl p-6 max-w-md w-5/12 transition-all duration-500 ease-in-out group-hover:bg-[#9A7B4F] group-hover:text-white ${
            index % 2 === 0 ? "ml-0" : "mr-0"
          }`}
          style={{
            boxShadow: "10px 10px 25px rgba(154, 123, 79, 0.2)",
          }}
        >
          {/* Speech Bubble Tail */}
          <div
            className={`absolute top-1/2 transform -translate-y-1/2 w-0 h-0 border-y-[10px] border-y-transparent ${
              index % 2 === 0
                ? "right-0 border-l-[20px] border-l-[#9A7B4F] group-hover:border-l-[white]"
                : "left-0 border-r-[20px] border-r-[#9A7B4F] group-hover:border-r-[white]"
            }`}
          ></div>

          {/* Step Number */}
          <h3 className="text-3xl font-bold transition-all duration-500 group-hover:text-white">
            {step.number}
          </h3>

          {/* Step Title */}
          <h4 className="text-lg font-semibold mt-3 transition-all duration-500 group-hover:text-white">
            {step.title}
          </h4>

          {/* Step Description */}
          <p className="text-sm mt-3 text-gray-600 transition-all duration-500 group-hover:text-gray-100">
            {step.description}
          </p>
        </div>

        {/* Step Icon */}
        <div
          className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-lg border-4 border-[#9A7B4F] absolute left-1/2 transform -translate-x-1/2 transition-all duration-500 group-hover:bg-[#9A7B4F] group-hover:border-white group-hover:shadow-[0_0_20px_5px_rgba(154,123,79,0.4)]"
        >
          <div className="text-[#9A7B4F] group-hover:text-white transition-all duration-500">
            {step.icon}
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

      <div className="bg-[#f5f2f2] px-10 py-20">
      <div className="text-center">
        <h2 className="text-4xl xsm:text-sm font-extrabold mb-4">Our Services</h2>
        <p className="text-lg text-gray-600 xsm:text-xs max-w-2xl mx-auto">
          Expert real estate services for buying, selling, and renting properties in the UAE
        </p>
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
        {services.map((service, index) => (
          <div
            key={index}
            className={` group p-8 rounded-lg shadow-lg bg-white transition duration-300 hover:bg-[#9A7B4F] hover:text-white `}
          >
            <div className={`w-14 xsm:w-7 xsm:h-7 h-14 flex items-center justify-center group-hover:bg-white group-hover:text-[#9A7B4F] transition-all duration-500 bg-[#9A7B4F] text-white rounded-md mb-6 xsm:text-sm text-2xl `}>
              {service.icon}
            </div>
            <h3 className={`text-xl xsm:text-sm font-semibold `}>
              {service.title}
            </h3>
            <p className={`mt-3 text-sm xsm:text-xs `}>
              {service.description}
            </p>
          </div>
        ))}
      </div>
    </div>
    <div className="bg-[#9A7B4F] text-white text-center py-16 relative">
          <div
            className="absolute bottom-0 left-0 right-0 opacity-90 bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${cityback})`, height: "100%" }}
          ></div>

          <div className="relative z-10 flex lg:flex-row xsm:flex-col md:flex-col md:gap-10 md:px-10 xsm:gap-10 xsm:px-8 justify-center gap-32">
            <div className=" text-start">
              <h2 className="text-4xl xsm:text-base font-bold">
                Find Your Dream Property Today <br /> — Let’s Get Started!
              </h2>
              <p className="mt-4 text-lg text-[#d1d5db] xsm:text-xs">
                Start your real estate journey with us now and discover the
                perfect <br /> property that suits your lifestyle and budget.
              </p>
            </div>

            <div className="flex items-center justify-center">
              <button className=" bg-white  text-black px-3 py-2 text-sm font-bold  rounded-full shadow-lg hover:bg-[#f5f3f1] transition duration-300">
                FIND NOW! →
              </button>
            </div>
          </div>
        </div>

      <Footer />
    </div>
  );
};

export default WhyUs;
